import { useState } from "react";

const TooltipIcon = ({ icon: Icon, text, color }) => {
  const [show, setShow] = useState(false);

  return (
    <div
      className="relative"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <Icon className={`text-3xl cursor-pointer ${color} transition-transform duration-200 hover:scale-110`} />

      {show && (
        <div className="absolute top-12 left-1/2 -translate-x-1/2 
                        bg-gray-900 text-white px-5 py-3 rounded-xl 
                        shadow-2xl text-base whitespace-nowrap z-20
                        opacity-0 animate-fadeIn transform -translate-y-2"
             style={{ animation: 'fadeInTooltip 0.3s forwards' }}
        >
          {text}

          {/* strzałka */}
          <div className="absolute -top-2 left-1/2 -translate-x-1/2 
                          w-0 h-0 border-l-8 border-r-8 border-b-8 
                          border-l-transparent border-r-transparent 
                          border-b-gray-900" />
        </div>
      )}

      {/* Dodajemy animację w tailwind jeśli nie masz -> można w CSS */}
      <style jsx>{`
        @keyframes fadeInTooltip {
          0% { opacity: 0; transform: translateY(-5px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default TooltipIcon;